<script lang="ts" setup>
	import { useClipboard } from '@vueuse/core'

	const props = defineProps<{
		text?: string
		copyText?: string
		successLabel?: string
	}>()
	const { copy, isSupported } = useClipboard()
	const copyItem = async () => {
		if (isSupported.value) {
			if (props?.text || props?.copyText) {
				try {
					await copy(String(props?.copyText || props?.text))
					useNotification().alert({
						status: 200,
						message: `${props.successLabel || ''} Copied to clipboard.`
					})
				} catch (error) {
					useNotification().alert({
						status: 500,
						message: "Something went wrong: You can't copy item"
					})
				}
				return null
			}
			useNotification().alert({
				status: 500,
				message: 'No item to copy'
			})
			return null
		}
		useNotification().alert({
			status: 500,
			message: 'Device does not support clipboard copy'
		})
	}
</script>

<template>
	<div aria-roledescription="copy button" aria-label="copy button text" role="button" @click="copyItem">
		<a-tooltip title="Click to copy" size="small" class="relative">
			<slot :text>
				{{ text || '' }}
			</slot>
		</a-tooltip>
	</div>
</template>
